import type { RouteObject } from 'react-router-dom';
import { useRoutes } from 'react-router-dom';
import { ScrollToTop } from '@/components/ScrollToTop';
import { PromoWidget } from '@/components/PromoWidget';
import About from '@/pages/About';
import AreasWeCover from '@/pages/AreasWeCover';
import Blog from '@/pages/Blog';
import Contact from '@/pages/Contact';
import FAQ from '@/pages/FAQ';
import Home from '@/pages/Home';
import PackingSupplies from '@/pages/PackingSupplies';
import Pricing from '@/pages/Pricing';
import Quote from '@/pages/Quote';
import Reviews from '@/pages/Reviews';
import Services from '@/pages/Services';
import Sitemap from '@/pages/Sitemap';
import { areaPages } from '@/lib/areaPages';
import { manAndVanPages } from '@/lib/manAndVanPages';
import { officeRemovalPages } from '@/lib/officeRemovalPages';
import { packingServicesPages } from '@/lib/packingServicesPages';
import { sameDayRemovalsPages } from '@/lib/sameDayRemovalsPages';
import { blogPosts } from '@/lib/blogPosts';
import { servicePages } from '@/lib/servicePages';
import { longDistanceRemovalsPages } from '@/lib/longDistanceRemovalsPages';
import { storageServicesPages } from '@/lib/storageServicesPages';
import { studentMovesPages } from '@/lib/studentMovesPages';

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/about', element: <About /> },
  { path: '/areas-we-cover', element: <AreasWeCover /> },
  { path: '/contact', element: <Contact /> },
  { path: '/quote', element: <Quote /> },
  { path: '/pricing', element: <Pricing /> },
  { path: '/reviews', element: <Reviews /> },
  { path: '/faq', element: <FAQ /> },
  { path: '/blog', element: <Blog /> },
  { path: '/sitemap', element: <Sitemap /> },
  { path: '/packing-supplies', element: <PackingSupplies /> },
  { path: '/services', element: <Services /> },
  ...servicePages.map((service) => ({ path: service.path, element: <service.component /> })),
  ...officeRemovalPages.map((office) => ({ path: office.path, element: <office.component /> })),
  ...manAndVanPages.map((mav) => ({ path: mav.path, element: <mav.component /> })),
  ...packingServicesPages.map((pack) => ({ path: pack.path, element: <pack.component /> })),
  ...storageServicesPages.map((storage) => ({ path: storage.path, element: <storage.component /> })),
  ...sameDayRemovalsPages.map((sameDay) => ({ path: sameDay.path, element: <sameDay.component /> })),
  ...studentMovesPages.map((student) => ({ path: student.path, element: <student.component /> })),
  ...longDistanceRemovalsPages.map((ld) => ({ path: ld.path, element: <ld.component /> })),
  ...blogPosts.map((post) => ({ path: post.path, element: <post.component /> })),
  ...areaPages.map((area) => ({ path: area.path, element: <area.component /> })),
];

function App() {
  const element = useRoutes(routes);
  return (
    <>
      <ScrollToTop />
      <PromoWidget />
      {element}
    </>
  );
}

export default App;
